import {UserAlertEntityFactory} from '../Entities/factory.js'
import {UserAlertsListValueObjectFactory} from '../ValueObjects/factory.js'
import {FromUserAlertRawDataToUserAlertEntityMapper} from './FromUserAlertRawDataToUserAlertEntityMapper.js'
import {FromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper} from './FromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper.js'
import {FromUserAlertsParamsToRequestValueObjectMapper} from './FromUserAlertsParamsToRequestValueObjectMapper.js'
import {HTTPNotificationsToUnseenSavedSearchMatchesMapper} from './HTTPNotificationsToUnseenSavedSearchMatchesMapper.js'
import {HTTPUserAlertsListResponseToUserAlertsValueObjectMapper} from './HTTPUserAlertsListResponseToUserAlertsValueObjectMapper.js'

export class UserAlertsMappersFactory {
  static hTTPUserAlertsListResponseToUserAlertsValueObjectMapper = ({config}) =>
    new HTTPUserAlertsListResponseToUserAlertsValueObjectMapper({
      config,
      userAlertsListValueObjectFactory: UserAlertsListValueObjectFactory.userAlertsListValueObject,
      fromUserAlertRawDataToUserAlertEntityMapper: UserAlertsMappersFactory.fromUserAlertRawDataToUserAlertEntityMapper(
        {
          config
        }
      )
    })

  static fromUserAlertRawDataToUserAlertEntityMapper = ({config}) =>
    new FromUserAlertRawDataToUserAlertEntityMapper({
      config,
      userAlertEntityFactory: UserAlertEntityFactory.userAlertEntity
    })

  static fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper = ({config}) =>
    new FromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper({
      config,
      filteredProvincesValueObject: UserAlertsListValueObjectFactory.filteredProvincesValueObject
    })

  static fromUserAlertsParamsToRequestValueObjectMapper = ({config}) =>
    new FromUserAlertsParamsToRequestValueObjectMapper({
      config,
      parsedUserAlertEntity: UserAlertEntityFactory.parsedUserAlertEntity
    })

  static hTTPNotificationsToUnseenSavedSearchMatchesMapper = ({config}) =>
    new HTTPNotificationsToUnseenSavedSearchMatchesMapper({
      config,
      unseenSavedSearchMatchesValueObject: UserAlertsListValueObjectFactory.unseenSavedSearchMatchesValueObject
    })
}
